var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StoreSuggestion',_vm._b({key:_vm.cmpKey},'StoreSuggestion',_vm.params,false))
}
var staticRenderFns = []

export { render, staticRenderFns }